/* eslint-disable react-hooks/exhaustive-deps */
import { Fragment, useCallback, useEffect, useState, useRef } from "react";
import SwiperCore, { Pagination, Navigation, Autoplay, EffectFade } from "swiper";
import PageHeading from "../../components/__simple/_pageheading";
import { useTranslation } from "react-i18next";
import Car from "../../components/car";
import { CarColorPicker } from "./components/colorPicker";
import { FilterButton } from "../../components/__simple/_filterButton";
import { OfferSections } from "../../sections/offersSection";
import Breadcrumb from "../../components/__simple/breadcrumb";
import InfoCircle from "../../components/__simple/_infoCirclejsx";
import Info from "../../components/_info";
import { useDispatch } from "react-redux";
import { changeIcons } from "../../_redux/slices/navSlice";
import axios from "axios";
import { InputField } from "../../components/_input/_input";
import { slugCombine } from "../../utils/slugManager";
import { DropDownInput } from "../../components/_input/_dropdown";
import config from "../../configuration/config.json";
import ImageGallery from "react-image-gallery";
import { groupBy, mapValues, omit } from "lodash";
import { CheckInput } from "../../components/_input/_checkInput";
import { Helmet } from "react-helmet";
import TestEparts from "../eparts/testEparts";
import { useSelector } from 'react-redux';
SwiperCore.use([Pagination, Navigation, Autoplay, EffectFade]);

export function VehicleOnlinePage() {
    const reduxBrands = useSelector((state) => state.apiData.data.reduxBrands);
    const { t: trans, i18n } = useTranslation(["inputs", "heading", "vehicales", "info"]);
    const [isFullScreen, setIsFullScreen] = useState(false);
    const popRef = useRef(null);
    const [gallery, setGallery] = useState([]);
    const [brandInfo, setBrandInfo] = useState({});
    const [vehicles, setVehicles] = useState([]);
    const [filteredVehicles, setFilteredVehicles] = useState([]);
    const [Featured, setFeatured] = useState([]);
    const GetUrl = config.baseURL + 'details';
    const [offerVehicle, setOfferVehicle] = useState([]);
    const [brands, setBrands] = useState([]);
    const dispatch = useDispatch();
    const [carFilter, setCarFilter] = useState(null);
    let lang = (i18n.language || 'ar');
    const languageDir = 'language-' + lang;
    const [searchValue, setSearchValue] = useState(null);
    const [activeINColor, setActiveINColor] = useState("");
    const [activeOutColor, setActiveOutColor] = useState("");
    const [dataRing, setDataRing] = useState({
        "main": 40000,
        "max": 750000,
        "minDistanceProp": 40000,
        "defaultValueProp": [40000, 750000]
    });
    const [valueRing, setValueRing] = useState({
        "start": 40000,
        "end": 750000
    });
    const [sections, setSections] = useState([
        {
            "GUID": "6a37a931-2a75-4b45-9073-2164123b7d08",
            "catId": 1,
            "NameAr": "سيدان",
            "NameEn": "SEDAN",
            "StorNum": "1"
        },
        {
            "GUID": "c4341689-4bc5-44c5-b948-2546aee65b92",
            "catId": 5,
            "NameAr": "كوبيه",
            "NameEn": "COUPES",
            "StorNum": "2"
        },
        {
            "GUID": "871e103b-9194-449a-a91c-9e4ef39ab805",
            "catId": 4,
            "NameAr": "متعددة الاستخدامات",
            "NameEn": "SUV",
            "StorNum": "3"
        },
        {
            "GUID": "7e9e1e76-4149-4781-b8c0-03c9c1159b6f",
            "catId": 2,
            "NameAr": "عائلية",
            "NameEn": "MVP",
            "StorNum": "4"
        },
        {
            "GUID": "0c1f4216-7320-4304-b316-b9de74c5a24b",
            "catId": 3,
            "NameAr": "مركبات تجارية",
            "NameEn": "COMMERCIAL",
            "StorNum": "5"
        }
    ]);
    function RequsetFeatured() {
        const Body = {
            "object": "SiteVehicleSpecial",
            "ObjectSettings": { "MetaData": false }
        };

        axios.request({
            url: GetUrl,
            data: Body, method: "POST", responseType: "json"
        })
            .then(function (response) {
                setFeatured(response.data.ApiObjectData);
            })
            .catch(function (error) {
                console.log(error);
            });
    }

    useEffect(async () => {
        //console.log("reduxBrands>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>:");
        //console.log("reduxBrands>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>:",reduxBrands);
    }, [reduxBrands]);
    const [cachSNImages, setCachSNImages] = useState({});
    async function FetchCarSNImages(SN) {

        try {

            //console.log("cachSNImages:", cachSNImages);
            if (cachSNImages[SN]) {

                const filterG = cachSNImages[SN];
                setGallery(filterG);

                if (popRef && filterG && filterG?.length > 0) {
                    popRef.current.toggleFullScreen();
                }

            } else {



                const response = await axios.post(
                    config.baseURL + 'func',
                    {
                        "Name": "siteFetchCarSNImages",
                        "Values": {
                            "SN": SN
                        }
                    }
                );

                if (response.status == 200) {


                    const filterG = [];

                    response.data?.map((item, index) => {
                        item["original"] = config.mainURL + item.Image;
                        item["thumbnail"] = config.mainURL + item.Image;
                        item["originalHeight"] = "50";
                        item["originalWidth"] = "50";
                        item["sizes"] = "50";
                        item["fullscreen"] = config.mainURL + item.Image;
                        filterG.push(item);


                    });

                    setGallery(filterG);

                    if (popRef && filterG && filterG?.length > 0) {
                        popRef.current.toggleFullScreen();
                    }

                    var cuCachSNImages = { ...cachSNImages };
                    cuCachSNImages[SN] = filterG;

                    setCachSNImages(cuCachSNImages);


                } else {

                    var cuCachSNImages = { ...cachSNImages };
                    cuCachSNImages[SN] = [];
                    setCachSNImages(cuCachSNImages);
                }

            }

        } catch (error) {
            console.log(error);

            var cuCachSNImages = { ...cachSNImages };
            cuCachSNImages[SN] = [];
            setCachSNImages(cuCachSNImages);

        }
    }


    useEffect(async () => {

        callback();

        const response = await axios.post(
            config.baseURL + 'func',
            {
                "Name": "siteFetchCarSNImages",
                "Values": {
                    "SN": null
                }
            }
        );

        if (response.status == 200) {


            const filterG = [];

            response.data?.map((item, index) => {
                item["original"] = config.mainURL + item.Image;
                item["thumbnail"] = config.mainURL + item.Image;
                item["originalHeight"] = "50";
                item["originalWidth"] = "50";
                item["sizes"] = "50";
                item["fullscreen"] = config.mainURL + item.Image;
                filterG.push(item);


            });


            //console.log("filterG:", filterG);
            const groupResult = mapValues(groupBy(filterG, 'SN'), fList => fList.map(items => omit(items, 'SN')));


            //console.log("groupResult:", groupResult);

            setCachSNImages(groupResult);


        } else {

            var cuCachSNImages = { ...cachSNImages };
            setCachSNImages(cuCachSNImages);
        }

    }, []);


    const callback = useCallback(async () => {
        try {
            setFilteredVehicles([]);
            setVehicles([]);
            setOfferVehicle([]);
            setBrands([]);
            setBrandInfo({});
            var res = null;

            // try {
            //     if ("caches" in window) {
            //         var curl = "OnlineVehicles-" + lang;

            //         // Opening that particular cache
            //         const cacheStorage = await caches.open("HJWeb");

            //         // Fetching that particular cache data
            //         const cachedResponse = await cacheStorage.match(
            //             curl
            //         );
            //         var dataVehicles = await cachedResponse?.json();

            //         if (dataVehicles?.vehicles)
            //             setVehicles(dataVehicles.vehicles);
            //         if (dataVehicles?.brands)
            //             setBrands(dataVehicles.brands);

            //     }
            // } catch (error) {

            // }

            try {
                if ("caches" in window) {
                    var curl22 = "HomeExtra-" + lang;

                    // Opening that particular cache
                    const cacheStorage22 = await caches.open("HJWeb");

                    // Fetching that particular cache data
                    const cachedResponse22 = await cacheStorage22?.match(
                        curl22
                    );
                    let homeExtraRescach = await cachedResponse22?.json();

                    setOfferVehicle(homeExtraRescach?.offerVehicle);

                }

            } catch (error) {

            }
            res = await axios.request({
                baseURL: config.controllURL,
                url: lang + "/api/vehicles/OnlineVehicles",
                method: "get",
            });


            setVehicles(res.data.vehicles);
            setBrands(res.data.brands);
            const resdataVehicles = new Response(JSON.stringify(res.data));

            if ("caches" in window) {
                try {
                    // Opening given cache and putting our data into it
                    caches.open("HJWeb").then((cache) => {
                        cache.put("OnlineVehicles-" + lang, resdataVehicles);

                    });
                } catch (error) {

                }
            }


            const homeExtraRes = await axios.request({
                baseURL: config.controllURL,
                url: lang + "/api/home/HomeExtra",
                method: "get",
            });


            setOfferVehicle(homeExtraRes.data.offerVehicle);
            const data2 = new Response(JSON.stringify(homeExtraRes.data));

            if ("caches" in window) {
                try {
                    // Opening given cache and putting our data into it
                    caches.open("HJWeb").then((cache) => {
                        cache.put("HomeExtra-" + lang, data2);

                    });
                } catch (error) {

                }
            }


        } catch (error) {
            console.log(error);
        }
        RequsetFeatured();
    }, []);

    // function filterCars(brand) {
    //     setCarFilter(brand);
    //     let filterData = [];
    //     if (brand != null)
    //         filterData = vehicles.filter((car) => {
    //             return car.brand === brand;
    //         });
    //     else {
    //         filterData = vehicles;
    //     }

    //     const uniquetypes = Object.values(
    //         filterData.reduce((acc, vehicle) => {
    //           if (!acc[vehicle.type]) {
    //             acc[vehicle.type] = { ...vehicle, listTypeColors: [vehicle.siteOutColorImage] };
    //           } else {
    //             // Collect colors if the group already exists
    //             if (!acc[vehicle.type].listTypeColors.includes(vehicle.siteOutColorImage)) {
    //               acc[vehicle.type].listTypeColors.push(vehicle.siteOutColorImage);
    //             }
    //           }
    //           return acc;
    //         }, {})
    //       );
    //     console.log("uniquetypes:",uniquetypes);
    //     setFilteredVehicles(uniquetypes);
    // };
    const [checkedCateegores, setCheckedCateegores] = useState([]);
    const OnCheckCate = (event) => {
        const { id, checked } = event;

        var currentlistvalues = (prevCheckedBrands) => {
            if (checked) {
                // Add the brand ID to the array if checked
                return [...prevCheckedBrands, id];
            } else {
                // Remove the brand ID from the array if unchecked
                return prevCheckedBrands.filter((brandId) => brandId !== id);
            }
        }

        const listValues = currentlistvalues(checkedCateegores);
        setCheckedCateegores(listValues);
        filterCars(carFilter, listValues);
        //-----------------
    };
    function filterCars(brand, thisCheckedCateegores = checkedCateegores) {
        setCarFilter(brand);
        let filterData = [];

        if (brand != null) {
            filterData = vehicles.filter((car) => car.brand === brand);
        } else {
            filterData = vehicles;
        }


        if (thisCheckedCateegores != null && thisCheckedCateegores?.length > 0) {
            filterData = filterData.filter((car) => thisCheckedCateegores == null || thisCheckedCateegores?.length === 0 || thisCheckedCateegores.includes(car.carCategories));
        }


        if (valueRing.start > 40000 || valueRing.end < 750000) {
            filterData = filterData.filter((car) => parseFloat(car.minPrice) >= valueRing.start && parseFloat(car.minPrice) <= valueRing.end);

        }

        if (searchValue != null && searchValue != "") {

            filterData = filterData.filter((car) => car.descriptionEn.toLowerCase().includes(searchValue.toLowerCase()));
        }


        var uniquetypes = Object.values(
            filterData.reduce((acc, vehicle) => {
                const colorObj = { image: vehicle.siteOutColorImage, name: vehicle.colorName, colorID: vehicle.colorID };

                if (!acc[vehicle.type]) {
                    acc[vehicle.type] = {
                        ...vehicle,
                        listTypeColors: [colorObj]
                    };
                } else {
                    // Check if this color already exists in the list
                    const exists = acc[vehicle.type].listTypeColors.some(
                        (c) => c.image === vehicle.siteOutColorImage && c.name === vehicle.colorName
                    );
                    if (!exists) {
                        acc[vehicle.type].listTypeColors.push(colorObj);
                    }
                }

                return acc;
            }, {})
        );
        console.log("filterData activeOutColor:", activeOutColor);
        if (activeOutColor != null && activeOutColor != "") {

            uniquetypes = uniquetypes.filter(vehicle =>
                vehicle?.listTypeColors?.some(c => c.colorID === activeOutColor)
            );
        }
        console.log("uniquetypes:", uniquetypes);
        setFilteredVehicles(uniquetypes);
    }

    useEffect(() => {
        filterCars(carFilter);
    }, [valueRing, activeOutColor]);

    // to change the icons color on the navbar
    useEffect(() => {
        dispatch(
            changeIcons({ iconsBlack: true })
        )

        return () => {
            dispatch(
                changeIcons({ iconsBlack: false })
            )
        }
    }, []);

    // useEffect(() => {

    //     if (vehicles && vehicles.length > 0)
    //     {

    //           const uniquetypes = Object.values(
    //             vehicles.reduce((acc, vehicle) => {
    //               if (!acc[vehicle.type]) {
    //                 acc[vehicle.type] = { ...vehicle, listTypeColors: [vehicle.siteOutColorImage] };
    //               } else {
    //                 // Collect colors if the group already exists
    //                 if (!acc[vehicle.type].listTypeColors.includes(vehicle.siteOutColorImage)) {
    //                   acc[vehicle.type].listTypeColors.push(vehicle.siteOutColorImage);
    //                 }
    //               }
    //               return acc;
    //             }, {})
    //           );
    //         console.log("uniquetypes:",uniquetypes);
    //         setFilteredVehicles(uniquetypes);
    //     }

    // }, [vehicles]);


    useEffect(() => {
        if (vehicles && vehicles.length > 0) {
            const uniquetypes = Object.values(
                vehicles.reduce((acc, vehicle) => {
                    const colorObj = {
                        image: vehicle.siteOutColorImage,
                        name: vehicle.colorName,
                        colorID: vehicle.colorID
                    };

                    if (!acc[vehicle.type]) {
                        acc[vehicle.type] = {
                            ...vehicle,
                            listTypeColors: [colorObj]
                        };
                    } else {
                        const exists = acc[vehicle.type].listTypeColors.some(
                            (c) => c.image === colorObj.image && c.name === colorObj.name
                        );
                        if (!exists) {
                            acc[vehicle.type].listTypeColors.push(colorObj);
                        }
                    }

                    return acc;
                }, {})
            );

            console.log("uniquetypes:", uniquetypes);
            setFilteredVehicles(uniquetypes);
        }
    }, [vehicles]);

    const [seoPageInfo, setSeoPageInfo] = useState({});
    useEffect(async () => {

        var page = "Online Cars Store"


        const response = await axios.post(
            config.baseURL + 'func',
            {
                "Name": "SiteFetchSeoPages",
                "Values": {
                    "page": page
                }
            }
        );
        if (response.status == 200) {

            var resdata = response.data[0];

            setSeoPageInfo(resdata);


        }
    }, []);

    return (

        <>

            <Fragment>

                {
                    seoPageInfo &&

                    <Helmet>

                        <meta charSet="utf-8" />
                        {
                            seoPageInfo?.title &&
                            <title>{seoPageInfo?.title}</title>
                        }
                        {
                            seoPageInfo?.link &&
                            <link rel="canonical" href={seoPageInfo?.link} />

                        }
                        {
                            seoPageInfo?.MetaDescription &&
                            <meta name="description" content={seoPageInfo?.MetaDescription} />
                        }
                        {
                            seoPageInfo?.MetaGroups &&
                            <meta name="keywords" content={seoPageInfo?.MetaGroups} />
                        }

                    </Helmet>


                }

                <div className="container mt-xs flex nice-align-item-center" >
                    <Breadcrumb className={"mt-16 "}
                        links={[
                            {
                                name: trans("info:Online_Cars_Store")
                            }
                        ]}
                    />

                    <div className="bg-primary px-10 py-2 border-radius-full mx-5">
                        <span className="text-white text-20">{lang == "ar" ? "اصدار تجريبي" : "BETA"}</span>
                    </div>
                </div>
                <div className="container mb-32 ">

                    {
                        brandInfo && brandInfo?.name &&
                        <PageHeading
                            fixed={true}
                            subtitle={brandInfo?.name && trans("vehicales:showroom").replace("{brand}", brandInfo?.name)}
                            title={brandInfo?.name && trans("vehicales:showroom_desc").replace("{brand}", brandInfo?.name)}
                        />
                    }


                    <div className="nice-row">
                        <div className="nice-col-lg-2 nice-col-md-3 mt-20">
                            <div className="helper mt-40">


                                <div className=" sm:col-span-1 md:col-span-3 lg:col-span-3 xl:col-span-3 mb-20">
                                    {
                                        <div className={"flex justify-center items-center "}>
                                            <div className="filter-search-grid filter-search-1 h-90">

                                                <InputField
                                                    searchIconClasses={" w-20-important "}
                                                    searchIcon={true}
                                                    extraClasses="part-input-search text-16 "
                                                    // placeholder={trans("new:product_no")}
                                                    placeholder={trans("info:search")}
                                                    onChangeValue={(e) => {

                                                        setSearchValue(e.target.value);
                                                    }
                                                    }
                                                    onClicksearchIcon={(value) => {

                                                        filterCars(carFilter);
                                                    }}
                                                    value={searchValue}
                                                />
                                            </div>
                                        </div>
                                    }
                                </div>
                                <hr className='mt-10' />
                                {/*{"البحث بالرنج"}*/}
                                <div className='flex flex-col mb-10 w-full'>
                                    <span className="flex nice-item-center text-center text-bold text-16">{trans('info:price')}
                                        <i className="text-bold text-20 icon-icomoon-Saudi_Riyal_Symbol-2 "></i> </span>
                                    <TestEparts
                                        className=''
                                        minProp={dataRing.main} maxProp={dataRing.max}
                                        minDistanceProp={10000}
                                        defaultValueProp={dataRing.defaultValueProp}
                                        returnProp={(value) => {
                                            console.info("console.info:  ", value);
                                            setValueRing(value);
                                        }}
                                    />
                                </div>
                                <hr className='mt-10' />
                                <div className='flex flex-col helper-section-heading mb-10 '>

                                    <span className="text-center text-bold text-16 mb-10">{trans("new:categories")} </span>
                                    {sections.map(B => {
                                        if (lang === "en") {

                                            return (
                                                <CheckInput id={B.catId} className=' cursor-pointer' labelClassName=' ' oncheng={OnCheckCate}
                                                    Name={"CH_SEC" + B.catId}>
                                                    <label
                                                        htmlFor={B.catId} className='helper-section-label'>{B.NameEn}</label>
                                                </CheckInput>);

                                        } else {
                                            return (
                                                <CheckInput id={B.catId} className=' cursor-pointer' labelClassName='  ' oncheng={OnCheckCate} Name={"CH_SEC" + B.catId}>
                                                    <label
                                                        htmlFor={B.catId} className='helper-section-label'>{B.NameAr}</label>
                                                </CheckInput>);
                                        }
                                    })}
                                </div>

                                <hr className='mt-10' />

                                <div className='flex flex-col helper-section-heading mb-10 '>

                                    <div className="my-10">
                                        <DropDownInput
                                            title={trans("form:color")}

                                            options={vehicles
                                                .filter((color, index, self) =>
                                                    index === self.findIndex(c => c.colorID === color.colorID) && color.siteOutColorImage != null
                                                )
                                                .map(color => ({
                                                    value: color.colorID,
                                                    text: color.colorNameAr
                                                }))
                                            }
                                            onSelect={(color) => {
                                                if (color != activeOutColor) {
                                                    // setSelectedColor([]);
                                                    setActiveOutColor(color);

                                                }

                                            }}
                                            selectedValue={activeOutColor}
                                        />
                                    </div>
                                    {/* <span className="text-center text-bold text-16 mb-10">{trans("info:الالوان")} </span>

                                    <div className=' grid grid-template-columns-auto gap-2 mb-10 '>
                                        {
                                            vehicles.length > 0 &&
                                            vehicles.filter((color, index, self) =>
                                                index === self.findIndex(c => c.colorID === color.colorID) && color.siteOutColorImage != null
                                            )
                                                .map((color, index) => {
                                                    return (
                                                        <CarColorPicker
                                                            title={color?.colorNameAr}
                                                            style={{ width: '100%', height: '4rem' }}
                                                            key={index}
                                                            urlImageColor={color.siteOutColorImage}
                                                            // imageBase64={color.siteOutColorImage}
                                                            color={color?.colorID}
                                                            name={color?.colorNameAr}
                                                            onClick={() => {
                                                                if (color.colorID != activeOutColor) {
                                                                    // setSelectedColor([]);
                                                                    setActiveOutColor(color.colorID);

                                                                }

                                                            }}
                                                            active={activeOutColor} />

                                                    );
                                                })
                                        }
                                    </div> */}

                                </div>
                                <hr className='mt-10' />
                                <div className='helper-section-heading my-5 pb-8 border-b'>
                                    <a
                                        href={"/" + lang + "/VehicleOnline"}
                                        className="font-bold text-3xl nice-line-underline sm:text-3xl md:text-2xl cursor-pointer hover:text-[#3bd461]"
                                        onClick={async (e) => {

                                            // setNameCat({ catAr: null, catEn: null });
                                            // //console.log("e.target.innerHTML: ", e.target.innerHTML);
                                            // setClearFilter(true);


                                            // setIsStock(false);
                                            // await clearFiltersFunction({ _isStock: false });
                                        }}
                                    >
                                        {trans("info:clear-all-filters")}
                                    </a>
                                </div>

                            </div>
                        </div>
                        <div className={"nice-col-lg-10 nice-col-md-9 mb-32  " + languageDir}>
                            <div className={"vehicle-filter-group start mb-24 mx-auto"}>

                                <div className="filter-btns">

                                    <FilterButton name={trans("inputs:all")} isActive={carFilter == null}
                                        onclick={() => filterCars(null)} />
                                    {
                                        brands.map((brand, index) => {
                                            return (
                                                <FilterButton key={index} name={brand.name} isActive={carFilter == brand.name} onclick={() => filterCars(brand.name)} />
                                            );
                                        })
                                    }


                                </div>

                            </div>
                            <div className="grid gap-4 grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 xl:grid-cols-4   mb-16 vehicle-gap">
                                {
                                    filteredVehicles?.map((vehicle, index) => {
                                        // if (parseFloat(vehicle.minPrice) != '0')
                                        return (
                                            <div key={vehicle?.productTarget + "_" + vehicle?.colorID + "_" + index} className="  my-20 ">
                                                <Car

                                                    className="h-100"
                                                    group={vehicle.group}
                                                    slug={vehicle.productTarget}
                                                    year={vehicle.year}
                                                    colorID={vehicle.colorID}
                                                    gifts={vehicle.countGifts}
                                                    groupType={vehicle.carGroupID}
                                                    modelType={vehicle.type}
                                                    hybridImage={vehicle.hybridImage}
                                                    brandImage={vehicle.BrandImage}
                                                    discountPrice={vehicle.discount}
                                                    ProductId={vehicle.productID}
                                                    img={vehicle.image}
                                                    name={vehicle.descriptionEn?.replace(vehicle?.brandEn, "") + " " + vehicle.year}
                                                    brand={vehicle.brand}
                                                    brandID={vehicle?.brandID}
                                                    category={vehicle.categor}
                                                    minPrice={vehicle.minPrice}
                                                    miniDownPayment={vehicle?.miniDownPayment}
                                                    Tax={vehicle.Tax}
                                                    RateCareDiscount={vehicle.RateCareDiscount}
                                                    newCar={vehicle.newCar}
                                                    hybird={vehicle.hybird}
                                                    desc={vehicle.desc}
                                                    modelTypes={vehicle?.modelDescription?.replace(vehicle?.brand, "")}
                                                    // link={"/vehicles/" + slugCombine(vehicle.brand, vehicle.otherBrand) + "/" + vehicle.productTarget}
                                                    link={"/" + lang + "/car/Overview/" + vehicle?.sn + "/" + vehicle.productTarget}
                                                    brandIcon={vehicle.brandIcon}
                                                    type={vehicle.type}
                                                    showPric={vehicle.showPric}
                                                    buyOnline={vehicle?.buyOnline}
                                                    goBuyDerict={true}
                                                    colorName={vehicle?.colorName ? vehicle?.colorName : null}
                                                    carData={vehicle}
                                                    onClickShowSN={(SN) => FetchCarSNImages(vehicle?.sn)}
                                                    btnShowSN={(cachSNImages && cachSNImages[vehicle?.sn]) ? true : false}

                                                    listcolors={vehicle?.listTypeColors ?? []}
                                                />
                                            </div>
                                        )
                                    })
                                }
                            </div>

                        </div>
                    </div>
                </div>

                {
                    offerVehicle &&
                    <OfferSections title={trans("info:vehicle_offers")} offersList={offerVehicle} />
                }
                <div className={"container mb-32 " + languageDir}>
                    <div className="mx-20 flex flex-row justify-center flex-wrap items-center nice-gap-1rem">

                        {Featured?.map(a => (

                            <InfoCircle
                                icon={"data:image/image;base64," + a.icon}
                                titleAr={a.titleAr}
                                titleEn={a.titleEn}
                            />
                        ))}


                    </div>
                </div>

                <div className="container mb-32">
                    <Info />
                </div>

                {/* <div className="beta-tag mb-32">
                <span className="text-white text-30">{"اصدار تجريبي"}</span>
            </div> */}




            </Fragment>

            <div className={""} style={{ opacity: (isFullScreen == true ? 1 : 0), position: (isFullScreen == true ? "relative" : "fixed"), zIndex: (isFullScreen == true ? 999999 : -1) }}>
                <ImageGallery ref={popRef} items={gallery} onScreenChange={(e) => {

                    setIsFullScreen(e);
                }} />
            </div>
        </>
    );
}